import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_CLUBS = "clubs";
const BASE_URL = "/api/clubs";

const ClubQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const CLUB_EMPTY = {
    provincie: "",
    sector: "",
    stamNummer: "",
    club: "",
    lokaal: "",
    adres: "",
    adres2: "",
    telefoon: "",
    functieClub: "",
    email: "",
    active: true,
    voorzitters: [],
    penningsMeesters: [],
    secretarissen: [],
    raadsLeden: []

};

export function useClubs() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_CLUBS],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...ClubQueryConfig
    });
    return {...result, clubs: result.data};
}


export function useClub(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_CLUBS, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...ClubQueryConfig
    });
    return {...result, club: result.data};
}

export function useClubMutations() {
    async function createFunction(club) {
        if (!club) return;
        return await fetchPOST(BASE_URL, club, false);
    }

    async function editFunction(club) {
        if (!club) return;
        return await fetchPUT(`${BASE_URL}/${club.id}`, club);
    }

    async function editAddNewFiles(club) {
        if (!club) return;
        return await fetchPUT(`${BASE_URL}/${club.id}/files`, club.filesIds);
    }

    async function deleteFunction(club) {
        return await fetchDELETE(`${BASE_URL}/${club.id}`)
    }

    return {
        createClub: useMyMutation(createFunction, REACT_QUERY_ID_CLUBS, club => `Club ${club.title} created`),
        editClub: useMyMutation(editFunction, REACT_QUERY_ID_CLUBS, club => `Club ${club.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_CLUBS, club => `Club ${club.title} modified`),
        deleteClub: useMyMutation(deleteFunction, REACT_QUERY_ID_CLUBS, club => `Club ${club.title} deleted.`)
    };

}